import React from 'react';
import { Section } from './ui/Section';
import { Check, X } from 'lucide-react';
export function TargetAudience() {
  return <Section className="bg-gray-900 text-white" data-id="element-147">
      <div className="grid md:grid-cols-2 gap-0 border-4 border-white" data-id="element-148">
        {/* Es para ti */}
        <div className="p-8 md:p-12 border-b-4 md:border-b-0 md:border-r-4 border-white bg-black" data-id="element-149">
          <h3 className="text-3xl font-bold mb-8 text-green-400 uppercase flex items-center" data-id="element-150">
            <Check className="w-8 h-8 mr-3" data-id="element-151" /> Es para ti si…
          </h3>
          <ul className="space-y-4" data-id="element-152">
            {['Eres hombre muy ocupado (25–55 aprox.)', 'Estás quebrado o estancado hace años', 'Te da vergüenza tu situación actual', 'Ya compraste cursos y sigues pobre', 'Quieres reglas simples que puedas ejecutar incluso cansado'].map((item, i) => <li key={i} className="flex items-start text-lg text-gray-300" data-id="element-153">
                <span className="mr-3 text-green-500" data-id="element-154">•</span> {item}
              </li>)}
          </ul>
        </div>

        {/* No es para ti */}
        <div className="p-8 md:p-12 bg-gray-900" data-id="element-155">
          <h3 className="text-3xl font-bold mb-8 text-red-500 uppercase flex items-center" data-id="element-156">
            <X className="w-8 h-8 mr-3" data-id="element-157" /> No es para ti si…
          </h3>
          <ul className="space-y-4" data-id="element-158">
            {['Buscas dinero fácil sin hacer nada', 'Quieres motivación en vez de ejecución', 'No toleras rechazo', 'No estás dispuesto a enviar mensajes en frío'].map((item, i) => <li key={i} className="flex items-start text-lg text-gray-400" data-id="element-159">
                <span className="mr-3 text-red-500" data-id="element-160">•</span> {item}
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}